import contactService from "../../../services/contact.service"

export default {
    async fetchContactList({ commit, dispatch }, payload) {
        return contactService.getContacts(payload)
            .then(response => {
                commit('SET_CONTACT_LIST', response.data)
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    commit('SET_CONTACT_LIST', [])
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async fetchContactListConditions({ commit, dispatch }, payload) {
        return contactService.getContacts(payload)
            .then(response => {
                commit('SET_CONTACT_LIST_CONDITIONS', response.data.data)
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (Object.values(error.errors).length > 0) {
                    commit('SET_CONTACT_LIST_CONDITIONS', [])
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async fetchContact({ dispatch }, id) {
        return contactService.getContact(id)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
    async create({ dispatch }, params) {
        return contactService.createNewContact(params)
            .then(response => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
                return Promise.resolve(response)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
                return Promise.reject(error)
            })
    },
    async update({ dispatch }, data) {
        return contactService.updateContact(data)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
                return Promise.resolve(response)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
                return Promise.reject(error)
            })
    },
    async delete({ dispatch }, id) {
        return contactService.deleteContact(id)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
                return Promise.resolve(response.data)
            })
            .catch(error => {
                if (typeof error.errors == 'object') {
                    if (Object.values(error.errors).length > 0) {
                        dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
            })
    },
}
